export const FETCH_CARE_HEARTH_BUYERS = "app/CareHearthBuyers/FETCH_BUYERS";
export const FETCH_CARE_HEARTH_BUYERS_SUCCESS =
  "app/CareHearthBuyers/FETCH_BUYERS_SUCCESS";
export const FETCH_CARE_HEARTH_BUYERS_FAILURE =
  "app/CareHearthBuyers/FETCH_BUYERS_FAILURE";

export const FETCH_CARE_HEARTH_BUYER = "app/CareHearthBuyers/FETCH_BUYER";
export const FETCH_CARE_HEARTH_BUYER_SUCCESS =
  "app/CareHearthBuyers/FETCH_BUYER_SUCCESS";
export const FETCH_CARE_HEARTH_BUYER_FAILURE =
  "app/CareHearthBuyers/FETCH_BUYER_FAILURE";

export const RECALCULATE_CARE_HEARTH_BUYER =
  "app/CareHearthBuyers/RECALCULATE_BUYER";
export const RECALCULATE_CARE_HEARTH_BUYER_SUCCESS =
  "app/CareHearthBuyers/RECALCULATE_BUYER_SUCCESS";
export const RECALCULATE_CARE_HEARTH_BUYER_FAILURE =
  "app/CareHearthBuyers/RECALCULATE_BUYER_FAILURE";

// Auto-buy invoices (15 October 2026): one per home per month.
export const FETCH_CARE_HEARTH_INVOICES = "app/CareHearthBuyers/FETCH_INVOICES";
export const FETCH_CARE_HEARTH_INVOICES_SUCCESS =
  "app/CareHearthBuyers/FETCH_INVOICES_SUCCESS";
export const FETCH_CARE_HEARTH_INVOICES_FAILURE =
  "app/CareHearthBuyers/FETCH_INVOICES_FAILURE";

export const MARK_CARE_HEARTH_INVOICE_PAID =
  "app/CareHearthBuyers/MARK_INVOICE_PAID";
export const MARK_CARE_HEARTH_INVOICE_PAID_SUCCESS =
  "app/CareHearthBuyers/MARK_INVOICE_PAID_SUCCESS";
export const MARK_CARE_HEARTH_INVOICE_PAID_FAILURE =
  "app/CareHearthBuyers/MARK_INVOICE_PAID_FAILURE";

// The Disputes list (15 October 2026): by month and home, and raising one for
// a home on its behalf.
export const FETCH_CARE_HEARTH_DISPUTES = "app/CareHearthBuyers/FETCH_DISPUTES";
export const FETCH_CARE_HEARTH_DISPUTES_SUCCESS =
  "app/CareHearthBuyers/FETCH_DISPUTES_SUCCESS";
export const FETCH_CARE_HEARTH_DISPUTES_FAILURE =
  "app/CareHearthBuyers/FETCH_DISPUTES_FAILURE";

export const RAISE_CARE_HEARTH_DISPUTES = "app/CareHearthBuyers/RAISE_DISPUTES";
export const RAISE_CARE_HEARTH_DISPUTES_SUCCESS =
  "app/CareHearthBuyers/RAISE_DISPUTES_SUCCESS";
export const RAISE_CARE_HEARTH_DISPUTES_FAILURE =
  "app/CareHearthBuyers/RAISE_DISPUTES_FAILURE";
